import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RichContentViewer from "../../../Shared/RichContentViewer";
import { Box, Button, Chip } from "@mui/material";
import { getWeight, getWeightLabel, STATUS_CONFIG } from "./Webview-v2";
import { Forum, MoneyOff, AccountBalance, Campaign } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const PROJECT_TYPE_CHIP = {
  "no-cost":    { label: "No Cost", color: "success" },
  "corpus":     { label: "Corpus", color: "secondary" },
  "fund-raise": { label: "Fund Raise", color: "warning" },
};

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const WEIGHT_COLOR = (w) => (w >= 8 ? "error" : w >= 5 ? "warning" : "success");

export default function MobileView({ each, createOrLoadDiscussionCb }) {
  const [expanded, setExpanded] = React.useState(false);
  const weight = getWeight(each);
  const statusCfg = STATUS_CONFIG[each.status] || STATUS_CONFIG.open;

  return (
    <Card
      elevation={0}
      sx={{
        mb: 1,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        borderLeft: 3,
        borderLeftColor: `${statusCfg.color}.main`,
      }}
    >
      <CardContent sx={{ pb: 0.5, pt: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.75 }}>
          <Typography
            variant="caption"
            color="primary"
            fontWeight="bold"
            sx={{ cursor: "pointer" }}
            onClick={() => createOrLoadDiscussionCb(each)}
          >
            #{each.projectNumber}
          </Typography>
          <Chip
            size="small"
            color={statusCfg.color}
            variant="outlined"
            label={statusCfg.label}
            sx={{ fontSize: 10, height: 20 }}
          />
          <Chip
            size="small"
            color={WEIGHT_COLOR(weight)}
            variant="outlined"
            label={getWeightLabel(weight)}
            sx={{ fontSize: 10, height: 20 }}
          />
          {each.projectType && PROJECT_TYPE_CHIP[each.projectType] && (
            <Chip
              size="small"
              color={PROJECT_TYPE_CHIP[each.projectType].color}
              label={PROJECT_TYPE_CHIP[each.projectType].label}
              sx={{ fontWeight: 600, fontSize: 10, height: 20 }}
            />
          )}
        </Box>

        <Typography variant="subtitle2" fontWeight={600}>
          {each.title}
        </Typography>
      </CardContent>

      <CardActions sx={{ px: 2, py: 0.5 }}>
        <Button
          onClick={() => createOrLoadDiscussionCb(each)}
          size="small"
          startIcon={<Forum sx={{ fontSize: 16 }} />}
          sx={{ borderRadius: 2, textTransform: "none", fontSize: "0.75rem" }}
        >
          Open
        </Button>
        <ExpandMore
          expand={expanded}
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-label="show more"
          size="small"
        >
          <ExpandMoreIcon fontSize="small" />
        </ExpandMore>
      </CardActions>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ px: 2, pb: 2 }}>
          <RichContentViewer content={each.description} />
        </Box>
      </Collapse>
    </Card>
  );
}
